module.exports = __webpack_public_path__ + "static/img/Group 19@3 1.4c2d5c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group 19@3 1.png
// module id = OQjT
// module chunks = 1